import * as React from "react";
import { forwardRef } from "react";
const SvgStopTimer = (props, ref) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, ...props }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M0 10C0 4.48 4.48 0 10 0C15.52 0 20 4.48 20 10C20 15.52 15.52 20 10 20C4.48 20 0 15.52 0 10ZM15 5H5V15H15V5Z", fill: "white" }));
const ForwardRef = forwardRef(SvgStopTimer);
export default ForwardRef;
